
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as gQ8wDam8qKQeZ9BglyDzpciCj6qUhnutY_8A_45v5iNTKoMeta } from "/codebuild/output/src1435589556/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue?macro=true";
import { default as indexqWrkm0Kugb3IWhSe6lnwmvMJ3Pfhpi8biFABIYXV3_45sMeta } from "/codebuild/output/src1435589556/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue?macro=true";
import { default as searchLyFcElylZIS0UBRc3DhWS3CWP9TCmZQ94rEP4qR9BRcMeta } from "/codebuild/output/src1435589556/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue?macro=true";
import { default as indexorIoHFKQ2KkIsUWaGGRFpCCHE2KFbgWBDIoqDU42Gk0Meta } from "/codebuild/output/src1435589556/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue?macro=true";
import { default as _91id_93jINVT1UAH9f2l98fzEImDLxS4w9lv8lPwCvHWuiCHGMMeta } from "/codebuild/output/src1435589556/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue?macro=true";
import { default as indexGTVjJUL5hooqw9PGb_45P60OmchoAQc8PwMLEVVHq5smUMeta } from "/codebuild/output/src1435589556/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue?macro=true";
import { default as _91id_93a_GC8723kDblP39IImLy8oywPa_Com_45PqE2BNqXj3esMeta } from "/codebuild/output/src1435589556/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue?macro=true";
import { default as indexOTSBbAGYjyIjzJ0kH0nVfb7lqPdtBpqjn2bCqYGjIGIMeta } from "/codebuild/output/src1435589556/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue?macro=true";
import { default as _91id_93HQN_r3W8srsda4x3fG2ghLUTuutn03K6Fq9bgFW4gWIMeta } from "/codebuild/output/src1435589556/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue?macro=true";
import { default as indextmlTvn0FGYrjDnoWYK1lEqEcCKVWOhoEL2h_7tOkne0Meta } from "/codebuild/output/src1435589556/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue?macro=true";
import { default as indexqt7C6jVuUPGMbNoUyPos683Ha10tBLm68NX_lyW6F80Meta } from "/codebuild/output/src1435589556/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue?macro=true";
export default [
  {
    name: "g",
    path: "/g",
    component: () => import("/codebuild/output/src1435589556/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src1435589556/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/codebuild/output/src1435589556/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue")
  },
  {
    name: "v8",
    path: "/v8",
    component: () => import("/codebuild/output/src1435589556/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue")
  },
  {
    name: "video-id",
    path: "/video/:id()",
    component: () => import("/codebuild/output/src1435589556/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue")
  },
  {
    name: "terms",
    path: "/terms",
    meta: indexGTVjJUL5hooqw9PGb_45P60OmchoAQc8PwMLEVVHq5smUMeta || {},
    component: () => import("/codebuild/output/src1435589556/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue")
  },
  {
    name: "article-id",
    path: "/article/:id()",
    component: () => import("/codebuild/output/src1435589556/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue")
  },
  {
    name: "contact",
    path: "/contact",
    meta: indexOTSBbAGYjyIjzJ0kH0nVfb7lqPdtBpqjn2bCqYGjIGIMeta || {},
    component: () => import("/codebuild/output/src1435589556/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue")
  },
  {
    name: "v8-article-id",
    path: "/v8/article/:id()",
    component: () => import("/codebuild/output/src1435589556/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    meta: indextmlTvn0FGYrjDnoWYK1lEqEcCKVWOhoEL2h_7tOkne0Meta || {},
    component: () => import("/codebuild/output/src1435589556/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue")
  },
  {
    name: "privacy-policy-relationships",
    path: "/privacy-policy/relationships",
    meta: indexqt7C6jVuUPGMbNoUyPos683Ha10tBLm68NX_lyW6F80Meta || {},
    component: () => import("/codebuild/output/src1435589556/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue")
  }
]